import {createAction} from '@reduxjs/toolkit';

import type {AnyThread} from '../types/extended';

export const updateThreadLastViewedAt = createAction<{
    threadId: AnyThread['id'];
    lastViewedAt: AnyThread['last_viewed_at'];
}>('threads/actions/updateThreadLastViewedAt');
